module.exports = __webpack_public_path__ + "static/media/narayana.a6650c79.jpg";